var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0002 36.0002L30.0002 30.0002M30.0002 30.0002L24.0002 36.0002M30.0002 30.0002V43.5002M42.5852 39.5852C44.0482 38.7876 45.2039 37.5255 45.87 35.9982C46.5361 34.4708 46.6745 32.7651 46.2635 31.1503C45.8525 29.5354 44.9154 28.1035 43.6002 27.0804C42.285 26.0573 40.6665 25.5013 39.0002 25.5002H37.1102C36.6562 23.7441 35.8099 22.1137 34.6351 20.7317C33.4603 19.3497 31.9875 18.252 30.3273 17.5211C28.6672 16.7903 26.863 16.4453 25.0504 16.512C23.2377 16.5788 21.4638 17.0557 19.862 17.9067C18.2601 18.7578 16.8721 19.9609 15.8021 21.4256C14.7322 22.8903 14.0082 24.5785 13.6847 26.3633C13.3611 28.1481 13.4463 29.983 13.934 31.7301C14.4217 33.4772 15.299 35.091 16.5002 36.4502",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedicon);
export default __webpack_public_path__ + "static/media/Featuredicon.2c08f634c214db7636517b065cf6763d.svg";
export { ForwardRef as ReactComponent };